/* CSS Properties must be declared in global scope */
@property --card-stackable-comparison {
  syntax: "<length>";
  inherits: true;
  initial-value: 1px;
}
